import { createTheme } from '@mui/material/styles'

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#8BCF24',
      dark: '#57cf24',
      light: '#aafa32',
      contrastText: '#fff',
    },
    secondary: {
      main: '#000000',
    },
  },
  buttonLogin: {
    width: '170px',
    display: 'flex',
    margin: 'auto',
    mt: 1,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          backgroundColor: 'white',
        },
      },
      defaultProps: {
        position: 'fixed',
        color: 'inherit',
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
        },
        content: {
          marginLeft: 2,
          marginRight: 2,
        },
      },
    },
    MuiPaper: {
      variants: [
        {
          props: { variant: 'pageTitle' },
          style: {
            padding: '16px',
            height: '48px',
          },
        },
      ],
    },
    MuiCard: {
      variants: [
        {
          props: { variant: 'pageTitle' },
          style: {
            // borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            backgroundColor: '#f5f5f5',
            padding: '6px',
          },
        },
      ],
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          display: 'flex', // Use flexbox
          alignItems: 'center', // Vertically center children
          padding: '0 16px 0 16px',
          // padding: '0 16px 0 16px',
          // alignItems: 'baseline',
        },
        title: {
          fontWeight: 400,
          fontSize: '1.25rem',
          textTransform: 'uppercase',
          flexGrow: 1,
        },
        action: {
          margin: '0 0 0 16px',
          padding: 0,
        },
      },
    },
  },
})

export default customTheme
